import { carouselData } from '@/mocks/homeData';

export default function CarouselSection() {
  return (
    <section id="carousel" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="mb-8 md:mb-10">
          <span className="text-xs font-semibold text-accent-500 uppercase tracking-wider">✨ FEATURED</span>
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mt-2">精选专题</h2>
          <p className="text-sm text-foreground-500 mt-1">编辑精选的深度专题内容，发现更多漫画精彩</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {carouselData.map((item, idx) => (
            <a
              key={idx}
              href="#"
              className="group relative rounded-2xl overflow-hidden bg-background-100 cursor-pointer no-underline block h-[360px] md:h-[420px]"
            >
              <img
                src={item.imageUrl}
                alt={item.title}
                className="absolute inset-0 w-full h-full object-cover object-top transition-transform duration-700 group-hover:scale-105"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/20 to-transparent"></div>

              <div className="absolute bottom-0 left-0 right-0 p-6 md:p-8">
                <span className="inline-block px-3 py-1 text-xs font-medium bg-accent-500 text-background-50 rounded-full mb-3">
                  {item.tag}
                </span>
                <h3 className="text-xl md:text-2xl font-heading font-bold text-background-50 mb-2 group-hover:text-accent-300 transition-colors">
                  {item.title}
                </h3>
                <p className="text-sm text-background-200 leading-relaxed line-clamp-2">{item.desc}</p>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}